module.exports = __webpack_public_path__ + "img/curve_3.15c2381a.png";